var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / GD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 22.6666667,
    height: 14.6666667
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E21C30",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE1225",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-GD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#E42235",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1128",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.666667, 2.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#079B77",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7265052,7.46513824 C2.10400815,8.06926926 2.64598325,8.46804974 3.15078503,8.57039117 C3.42869756,8.62673402 2.91987048,7.35221286 3.14160185,7.21365972 C3.33079312,7.09543989 4.24105365,8.15532068 4.32076168,7.93419555 C4.50415509,7.42542756 4.3959697,6.70496135 3.98796678,6.05202021 C3.40263413,5.11529215 3.37978324,5.73354964 1.79739746,5.06248303 C1.9628457,6.02216414 1.14117254,6.52841018 1.7265052,7.46513824 L1.7265052,7.46513824 Z",
    id: "Oval-180",
    stroke: "none",
    fill: "#FFD938",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,7.33333333 L22.6666667,14.6666667 L0,14.6666667 L11.3333333,7.33333333 Z M22.6666667,0 L11.3333333,7.33333333 L0,0 L22.6666667,0 Z",
    id: "Rectangle-1129",
    stroke: "none",
    fill: "#FFD93B",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-179",
    stroke: "none",
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    cx: 11.3333333,
    cy: 7.33333333,
    r: 3.33333333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-96",
    stroke: "none",
    fill: "#FFD938",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "11.3333333 8.36172945 9.76590599 9.49071198 10.3552705 7.65112521 8.79718262 6.50928802 10.7288573 6.5013434 11.3333333 4.66666667 11.9378094 6.5013434 13.869484 6.50928802 12.3113962 7.65112521 12.9007607 9.49071198"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/GD.f5a3d72c0d26dcbb8811bf11b37ce500.svg";
export { ForwardRef as ReactComponent };